import { apiFetch } from '../client';

export function createEntryComment(entryID, comment) {
    return apiFetch('/dfr-api/comment/create/', {
        method: 'POST',
        body: JSON.stringify({entry_id: entryID, comment: comment})
    })
}

export function updateEntryComment(comment) {
    return apiFetch(`/dfr-api/comment/update/`, {
        method: 'POST',
        body: JSON.stringify({comment: comment})
    })
}

export function createEntryState(entryID, state) {
    return apiFetch('/dfr-api/state/create/', {
        method: 'POST',
        body: JSON.stringify({entry_id: entryID, state: state})
    })
}

export function updateEntryState(state) {
    return apiFetch(`/dfr-api/state/update/`, {
        method: 'POST',
        body: JSON.stringify({state: state})
    })
}

export function getEntryStates() {
    return apiFetch(`/dfr-api/get-states/`, {
        method: 'GET',
    })
}

export function getWindData(data) {
    return apiFetch(`/dfr-api/fetch-wind-rose/`, {
        method: 'POST',
        body: JSON.stringify(data)
    })
}

export function getWindEdgeRiskData(data) {
    return apiFetch(`/dfr-api/fetch-wind-edge-risk-zones/`, {
        method: 'POST',
        body: JSON.stringify(data)
    })
}

export function fetchWeatherData({ lmID, startDate, endDate }) {
    return apiFetch("/dfr-api/fetch-weather-tab/", {
      method: "POST",
      body: JSON.stringify({
        lmID: lmID,
        start_date: startDate,
        end_date: endDate,
      }),
    });
  }

export function fetchDFRPrices(data) {
    return apiFetch(`/dfr-api/fetch-prices/`, {
        method: 'POST',
        body: JSON.stringify(data)
    })
}

export function activatePlusonProp(prop, userID) {
    return apiFetch(`/subscription/plus/activate/`, {
        method: 'POST',
        body: JSON.stringify({
            lmID: prop.ref, 
            userID: userID
        })
    })
}

export function feedbackSubmission(data) {
    return apiFetch(`/dfr-feedback-submission/`, {
        method: 'POST',
        body: JSON.stringify({data: data})
    })
}